<div class="container">
    <form class="form" (ngSubmit)="onToDirect()" [formGroup]="toDirectForm">
        <div class="form-header">
            <app-tree-autocomplete [dptos]="departamentos" (onSelected)="trackDepartamentoChanges($event)" class="full-width"/>
            <mat-form-field class="full-width">
                <mat-label>Servidor p&uacute;blico</mat-label>
                <input type="text" matInput formControlName="participante" [matAutocomplete]="autoParticipante"
                    (focus)="selectAllText($event)">
                <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn">
                    @for (participante of participantesFiltered | async; track participante) {
                    <mat-option [value]="participante" style="display: block;">
                        <div><span>{{participante.apellidos.trim()+" "+participante.nombres.trim()}}</span> </div>
                        <small>{{(participante.cargo||'')+" "+participante.ciruc}} </small>
                        <span class="sgd-spacer"></span>
                        <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}"
                            style="float: inline-end; margin-right: 0;">man</mat-icon>
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Fecha m&aacute;xima</mat-label>
                <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="maxDate">
                <mat-hint>DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div style="display: flex; align-items: center;">
            <mat-form-field class="full-width">
                <mat-label>Comentario</mat-label>
                <textarea matInput formControlName="comment"></textarea>
            </mat-form-field>

            <button style="margin-bottom: 1.5rem; margin-left: 0.5rem;"
                [disabled]="toDirectForm.controls.participante.hasError('required') || toDirectForm.controls.comment.getRawValue()!.length<=0"
                (click)="onAddParticipant()" mat-icon-button matTooltip="Agregar" type="button">
                <mat-icon>person_add</mat-icon>
            </button>
        </div>

        <h5>Participantes a direccionar</h5>
        <div class="table-container" style="margin-bottom: 2rem;">
            <table mat-table [dataSource]="participantsDataSource">

                <ng-container matColumnDef="departamento">
                    <th mat-header-cell *matHeaderCellDef> Departamento </th>
                    <td mat-cell *matCellDef="let element"> {{element.departamento}} </td>
                </ng-container>

                <ng-container matColumnDef="participante">
                    <th mat-header-cell *matHeaderCellDef> Participante </th>
                    <td mat-cell *matCellDef="let element"> {{element.participante}} </td>
                </ng-container>

                <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef> Fecha </th>
                    <td mat-cell *matCellDef="let element"> {{formatDate(element.fecha)}} </td>
                </ng-container>

                <ng-container matColumnDef="comentario">
                    <th mat-header-cell *matHeaderCellDef> Comentario </th>
                    <td mat-cell *matCellDef="let element"> {{element.comentario}} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <button mat-icon-button matTooltip="Editar" type="button">
                            <mat-icon>edit</mat-icon>
                        </button> -->
                        <button mat-icon-button matTooltip="Eliminar"
                            (click)="deleteParticipant(element.participanteID)" type="button">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsParticipants"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsParticipants;"></tr>
            </table>
        </div>

        <div style="display: flex; gap: 1rem;">
            <button class="full-width" mat-button type="button" (click)="onCancel()">
                Cancelar
            </button>
            <button class="full-width" [disabled]="auxiliarAccionTareas.length==0 || fetchingReasignar" mat-flat-button
                type="submit">
                <div>
                    @if (fetchingReasignar) {
                    <mat-spinner diameter="20" color="warn"></mat-spinner>
                    }@else{
                    <p>Direccionar</p>
                    }
                </div>
            </button>
        </div>
    </form>

    <app-table-selected-documents [documentsInformation]="documentsInformation"></app-table-selected-documents>
</div>
